'use strict';

var eventemitter3 = {
  exports: {}
};
exports.__module = eventemitter3;
